import React from "react";

const BrokerIcon = (props: any) => {
  return (
    <div>
      <svg
        fill={props?.color ?? "#00000"}
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 568.065 568.065"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <path d="M328.234,293.221H239.82c-73.55,0-133.406,59.853-133.406,133.418v108.155l0.271,1.685l7.46,2.329 c70.196,21.929,131.195,29.258,181.401,29.258c98.048,0,154.886-27.964,158.408-29.736l6.963-3.535h0.732V426.639 C461.651,353.067,401.811,293.221,328.234,293.221z M304.625,503.101l-19.076,27.922c-0.261,0.391-0.671,0.609-1.126,0.609 c-0.013,0-0.024,0-0.036,0c-0.449,0-0.877-0.236-1.125-0.633l-17.724-27.945c-0.151-0.237-0.225-0.521-0.21-0.816l8.866-135.604 c0.047-0.722,0.635-1.265,1.363-1.265h18.395c0.721,0,1.312,0.543,1.371,1.265l9.527,135.593 C304.886,502.557,304.792,502.841,304.625,503.101z M295.997,361.277h-21.87l-19.009-39.294c0-3.771,3.05-6.81,6.821-6.81h45.655 c3.759,0,6.81,3.038,6.81,6.81L295.997,361.277z"></path>{" "}
              <path d="M179.841,181.915c0,57.551,46.648,104.213,104.207,104.213c57.533,0,104.192-46.662,104.192-104.213 c0-4.303-0.308-8.52-0.839-12.684H180.68C180.142,173.395,179.841,177.612,179.841,181.915z"></path>{" "}
              <path d="M157.22,155.412h15.161h10.982h201.342h20.699h5.449c12.502,0,22.645-10.143,22.645-22.65v-11.322 c0-12.507-10.143-22.65-22.645-22.65h-22.49V77.593C388.364,34.74,353.626,0,310.773,0h-61.111 c-42.85,0-77.593,34.74-77.593,77.593v21.196h-14.842c-12.504,0-22.647,10.143-22.647,22.65v11.322 C134.573,145.269,144.716,155.412,157.22,155.412z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    </div>
  );
};

export default BrokerIcon;
